import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import {
  BaseFpxDataService,
  ColumnType,
  CriteriaQuery,
  IColumnArray,
  SearchType,
  SortType,
  ToolBar,
  RoGridService,
  CellActionArray,
  RowActionArray
} from "@fpx/core";
import {
  debounce,
  debounceTime,
  map,
  Observable,
  of,
  Subject,
  take,
  takeLast,
  takeUntil,
  takeWhile,
} from "rxjs";
import { FormControlTemplatesService } from "src/app/templates/form-control-templates.service";

import { gsap } from "gsap";
import { ResponsiveService } from "src/app/responsive.service";

@Component({
  selector: "fpx-ro-grid",
  templateUrl: "./fpx-ro-grid.component.html",
  styleUrls: ["./fpx-ro-grid.component.scss"],
})
export class FpxRoGridComponent implements OnInit, OnDestroy {
  public mattabledataSource!: MatTableDataSource<any>;
  displayedColumns!: Array<string | any>;
  public displaycolumndefs!: ColumnDefinition[];
  @Input() searchPlaceholder: string = "";
  @Input() toolBarConfig: ToolBar[] = [];
  @Input() columnsArray!: IColumnArray<any>[];
  @Input() tableDatafn!: BaseFpxDataService<any>;
  @Input() title: string = "";
  @Input() gridWidth!: number;
  @Input() gridHeight!: number;
  @Input() pageSize: number = 10;
  @Input() showPagination!: boolean;
  @Input() gridId: string = "";
  @Input() cellActionArray: CellActionArray[] = [];
  @Input() templateClass: string = "";
  @Input() refreshGrid$: Observable<CriteriaQuery> = of(new CriteriaQuery());
  @Input() ngTemplateName!: string;
  @Input() interceptors: Map<"postFindall", any> = new Map<
    "postFindall",
    any
  >();
  @Input() multiRowSelect: boolean = true;
  @Input() rowActionArray: RowActionArray[] = [];
  @Input() enableSwipe: boolean = false;
  @Input() swipeOptions: any;
  @Output() handleActions: EventEmitter<{ name: string; data: any }> =
    new EventEmitter<{ name: string; data: any }>();
  @ContentChild(TemplateRef) template!: TemplateRef<any>;
  protected _selectedData: any;
  protected selectedRowId: string = "";
  tableData: any[] = [];
  criteriaQuery = new CriteriaQuery();
  searchFormGroup!: FormGroup;
  offset: number = 1;
  pageCount: number = 1;
  loading: boolean = true;
  visiblePages: number[] = [];
  totalPages: number = 0;
  destroy$: Subject<any> = new Subject();
  private _filterColumn: Array<{
    type: "String" | "Date" | "Number";
    key: string;
  }> = [];
  @Input("initialCriteria") initialCriteria;
  transfersSwipeLeft: any[];

  private ROW_ITEM_SWIPE_DURATION = 0;
  private ROW_ITEM_SWIPE_LEFT_MAX = 0;
  private ROW_ITEM_SWIPE_RIGHT_MAX = 0;
  //private ACCOUNT_CARD_SWIPE_DISTANCE = 0;

  private ACTION_DIV_WIDTH_RIGHT = 132;
  private ACTION_DIV_WIDTH_LEFT = 0;

  private rowItemSwipeLeftAIs: any = [];
  private rowItemSwipeRightAIs: any = [];
  private rowItemSwipeStates: any = [];
  private rowItemSwipeIndexes: any = [];

  private selectedRowItemIndex = -1;
  private swipedRowItemIndex = -1;
  private playInProgress = false;

  private panHorizontalInProgress = false;
  private scrollerunlistener: () => void;

  private touchState = {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
  };

  private rowItemTouchInProgress = false;
  private touchedRowItemIndex = null;

  actionOpned: boolean = false;
  randomNumber: Number;

  constructor(
    private _roGridService: RoGridService,
    private _fromControlTemplateService: FormControlTemplatesService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer2: Renderer2,
    private responsive: ResponsiveService
  ) { }

  getTemplate(ngTemplateName: string): TemplateRef<any> | null {
    let tmplt = this._fromControlTemplateService.getTemplate(
      ngTemplateName,
      "displayGrid"
    );
    return tmplt;
  }
  ngOnInit(): void {
    this.searchFormGroup = new FormGroup({});
    this.randomNumber = Math.floor(Math.random() * 999);
    
    if(this.swipeOptions?.actionRightWidth) this.ACTION_DIV_WIDTH_RIGHT = this.swipeOptions.actionRightWidth;

    this._setReadOnlyGridDependency();
    for (let i = 0; i < this.displaycolumndefs.length; i++) {
      if (this.displaycolumndefs[i].columnType) {
        this.searchFormGroup.addControl(
          `${this.displaycolumndefs[i].columnDef}`,
          new FormControl(
            {
              condition: this.displaycolumndefs[i].searchType,
              filter: this.displaycolumndefs[i].searchText,
              sort: this.displaycolumndefs[i].sortType,
            } ?? {}
          )
        );
        this.searchFormGroup
          .get(this.displaycolumndefs[i].columnDef)
          ?.valueChanges.subscribe({
            next: (res: {
              condition: SearchType;
              filter: string;
              sort: SortType;
            }) => {
              (this.search as any)[
                /** Hardcoded search need to replace with dynmanic  */
                `${this.displaycolumndefs[i].columnType}_Search`
              ](i, res);
              console.log(this.criteriaQuery.criteriaQuery());
              this._getGridData();
            },
          });
      }
    }

    this.searchFormGroup.addControl("templateSearch", new FormControl(""));
    this._templateSearch();

    this._roGridService.refreshGrid$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (id: string) => {
        if (this.gridId === id) {
          this._selectedData = null;
          this.pageCount = 1;
          this.offset = 1;
          this.criteriaQuery?.setPaginationCriteria(String(1), this.pageSize);
          this._getGridData();
        }
      },
      error: () => { },
      complete: () => { },
    });

    this.refreshGrid$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (criteria: CriteriaQuery) => {
        this._selectedData = null;
        this.pageCount = 1;
        this.offset = 1;
        if (this.initialCriteria) {
          this.criteriaQuery = this.initialCriteria;
        } else {
          this.criteriaQuery = criteria || new CriteriaQuery();
        }
        this.criteriaQuery?.setPaginationCriteria(String(1), this.pageSize);
        this._getGridData();
      },
      error: () => { },
      complete: () => { },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
    if (this.scrollerunlistener) {
      this.scrollerunlistener();
    }
    document.body.removeEventListener("touchmove", this.documentTouchMoveHandler.bind(this), { capture: true });
    this.teardownAnimations();
  }

  protected selectPage(page: number): void {
    this.pageCount = page;
  }

  private updateVisiblePages(): void {
    const length = Math.min(this.totalPages, this.pageSize);
    const startIndex = Math.max(
      Math.min(
        this.pageCount - Math.ceil(length / 2),
        this.totalPages - length
      ),
      0
    );
    this.visiblePages = Array.from(
      new Array(length).keys(),
      (item) => item + startIndex + 1
    );
  }

  private stringSearch = (
    i: number,
    res: {
      condition: SearchType;
      filter: string;
      sort: SortType;
    }
  ) => {
    if (this.displaycolumndefs[i].searchType) {
      this.criteriaQuery.addFilterCritertia(
        this.displaycolumndefs[i].columnDef,
        this.displaycolumndefs[i].columnType ?? "String",
        res.condition,
        {
          searchText: res.filter,
        }
      );
    }
    if (this.displaycolumndefs[i].sortType) {
      this.criteriaQuery.addSortCriteria(
        this.displaycolumndefs[i].columnDef,
        res.sort,
        this.displaycolumndefs[i].columnType ?? "String"
      );
    }
  };

  private stringRange = (
    i: number,
    res: {
      condition: SearchType;
      filter: string;
      sort: SortType;
    }
  ) => { };

  private dateSearch = (
    i: number,
    res: {
      condition: SearchType;
      filter: string;
      sort: SortType;
    }
  ) => { };

  private dateRange = (
    i: number,
    res: {
      condition: SearchType;
      filter: string;
      sort: SortType;
    }
  ) => { };

  private numericSearch = (
    i: number,
    res: {
      condition: SearchType;
      filter: string;
      sort: SortType;
    }
  ) => { };

  private numberRange = (
    i: number,
    res: {
      condition: SearchType;
      filter: string;
      sort: SortType;
    }
  ) => { };

  search = {
    String_Search: this.stringSearch,
    String_Range: this.stringRange,
    Date_Search: this.dateSearch,
    Date_Range: this.dateRange,
    Numeric_Search: this.numericSearch,
    Numeric_Range: this.numberRange,
  };

  private _setReadOnlyGridDependency() {
    this.displaycolumndefs = this.columnsArray.map((item) => {
      if (item.columnType === "String" && item.searchType) {
        this.criteriaQuery.addFilterCritertia(
          item.columnDef,
          item.columnType,
          item.searchType,
          {
            searchText: item.searchText,
          }
        );
        this._filterColumn.push({ type: "String", key: item.columnDef });
      } else if (item.columnType === "Date" && item.searchType) {
        this.criteriaQuery.addFilterCritertia(
          item.columnDef,
          item.columnType,
          item.searchType,
          {
            fromValue: item.fromValue,
            toValue: item.toValue,
          }
        );
        // this._filterColumn.push({ type : 'Date' , key : item.columnDef })
      }
      if (item.columnType && item.sortType) {
        this.criteriaQuery.addSortCriteria(
          item.columnDef,
          item.sortType,
          item.columnType
        );
      }

      return new ColumnDefinition(
        item.action,
        item.columnDef,
        item.header,
        item.cell,
        item.width,
        item.columnType,
        item.searchType,
        item.sortType,
        item.searchText,
        item.fromValue,
        item.toValue
      );
    });
    this.criteriaQuery.setPaginationCriteria("1", this.pageSize);
    this.displayedColumns = [...this.columnsArray.map((c: any) => c.columnDef)];
  }

  private _getGridData() {
    this.loading = true;
    this.tableDatafn
      ?.findAll?.(this.criteriaQuery)()
      .pipe(
        map((res) => {
          if (this.enableSwipe && !this.responsive.isDesktop() && this.rowActionArray.length) {
            setTimeout(() => {
              this.teardownAnimations();
              this.setupAnimations();
            });
          }
          if (this.interceptors.has("postFindall")) {
            return this.interceptors.get("postFindall")(res);
          } else {
            return res;
          }
        })
      )
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          if (res && res.data && res.data.length > 0) {
            this.tableData = res.data.map((item: any, index: number) => {
              return { id: this.getUniqueId(), ...item };
            });
          } else if (res && res.length > 0) {
            this.tableData = res.map((item: any, index: number) => {
              return { id: this.getUniqueId(), ...item };
            });
          } else {
            this.tableData = [];
          }
          if (this.tableData.length > 0) {
            this._selectedData = [];
            this.tableData.forEach((item, index) => {
              if (item?.isAlreadySelected) {
                let data = { ...item, index: index };
                this._selectedData.push(data);
              }
            });
          }
          this.totalPages = res?.totalRowCount
            ? Math.ceil(res.totalRowCount / 10)
            : Math.ceil(this.tableData.length / 10);
          this.updateVisiblePages();
          this.mattabledataSource = new MatTableDataSource<any>(this.tableData);
          this.mattabledataSource.filterPredicate = this._filterPredicate;
        },
        error: (err) => {
          this.loading = false;
          console.error(err);
          this.tableData = [];
          this.totalPages = 0;
          this.updateVisiblePages();
          this.mattabledataSource = new MatTableDataSource<any>(this.tableData);
        },
        complete: () => { },
      });
  }

  private _filterPredicate = (data: any, filter: string): boolean => {
    return this._filterColumn.some((keys) => {
      if (keys.type === "String") {
        return data[keys.key].toLowerCase().includes(filter?.toLowerCase());
      }
    });
  };

  onDoubleClick(event: MouseEvent, rowData: any) {
    this.handleActions.emit({
      name: "dbclick",
      data: rowData,
    });
  }

  getUniqueId(): string {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  onClick(event: MouseEvent, rowData: any): void {
    this.selectedRowId = rowData.id;
    this._selectedData = rowData;
    this.handleActions.emit({
      name: "onclick",
      data: rowData,
    });
  }

  onToolBarClick(action: string): void {
    if (action) {
      this.handleActions.emit({
        name: action,
        data: this._selectedData,
      });
    }
  }

  onBack(pageCount: number) {
    this.offset = this.offset - this.pageSize;
    this.pageCount = this.pageCount - 1;
    this.criteriaQuery.setPaginationCriteria(
      String(this.offset),
      this.pageSize
    );
    this._getGridData();
  }

  onNext(pageCount: number) {
    this.offset = this.offset + this.pageSize;
    this.pageCount = this.pageCount + 1;
    this.criteriaQuery.setPaginationCriteria(
      String(this.offset),
      this.pageSize
    );
    this._getGridData();
  }

  onFirstPage() {
    this.pageCount = 1;
    this.offset = 1;
    this.criteriaQuery.setPaginationCriteria(String(1), this.pageSize);
    this._getGridData();
  }

  onPageIndex(pageIndex: number) {
    this.pageCount = pageIndex;
    this.offset = pageIndex * 10 - 9;
    this.criteriaQuery.setPaginationCriteria(
      String(this.offset),
      this.pageSize
    );
    this._getGridData();
  }

  onLastPage() {
    this.pageCount = this.visiblePages.length;
    this.offset = this.pageCount * 10 - 9;
    this.criteriaQuery.setPaginationCriteria(
      String(this.offset),
      this.pageSize
    );
    this._getGridData();
  }

  onScroll() {
    console.log("scrolled done");
  }

  private _templateSearch() {
    this.searchFormGroup
      .get("templateSearch")
      ?.valueChanges.pipe(debounceTime(500))
      .subscribe({
        next: (value: any) => {
          this.mattabledataSource.filter = value;
        },
      });
  }

  boxClick(item: any, index: number) {
    if (this.multiRowSelect) {
      if (
        this._selectedData &&
        this._selectedData.some((item: any) => item.index === index)
      ) {
        this._selectedData = this._selectedData.filter(
          (item: any) => item.index !== index
        );
      } else if (
        this._selectedData &&
        !this._selectedData.some((item: any) => item.index === index)
      ) {
        this._selectedData.push({ ...item, index: index });
      } else {
        this._selectedData = [];
        this._selectedData.push({ ...item, index: index });
      }
    } else {
      this._selectedData = item;
    }

    this.handleActions.emit({ name: "onclick", data: this._selectedData });
  }

  rowActionClick(item: any, index: number, action: string) {
    this._selectedData = item;
    this.handleActions.emit({
      name: action,
      data: this._selectedData,
    });
  }

  onboxDoubleClick(item: any, index: number) {
    if (this.multiRowSelect) {
      if (
        this._selectedData &&
        this._selectedData.some((item: any) => item.index === index)
      ) {
        this._selectedData = this._selectedData.filter(
          (item: any) => item.index !== index
        );
      } else if (
        this._selectedData &&
        !this._selectedData.some((item: any) => item.index === index)
      ) {
        this._selectedData.push({ ...item, index: index });
      } else {
        this._selectedData = [];
        this._selectedData.push({ ...item, index: index });
      }
    } else {
      this._selectedData = item;
    }
    this.handleActions.emit({
      name: "onDoubleClick",
      data: this._selectedData,
    });
  }

  documentTouchMoveHandler($event) {
    this.touchState.y2 = $event.changedTouches && $event.changedTouches[0].clientY;
    this.touchState.x2 = $event.changedTouches && $event.changedTouches[0].clientX;
    let angle = 90;
    if (this.touchState.x2 != this.touchState.x1) {
      angle = Math.atan(Math.abs(this.touchState.y2 - this.touchState.y1) / Math.abs(this.touchState.x2 - this.touchState.x1)) * 57.32;
    }

    if (this.panHorizontalInProgress) {
      //console.log("Touch End", this.touchedRowItemIndex, this.rowItemSwipeStates[this.touchedRowItemIndex], angle);      
      //console.log("Cancel Pan In Progress Card", $event.cancelable);
      if ($event.cancelable) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    } else if (this.rowItemTouchInProgress) {
      //console.log("Touch Move", this.touchedRowItemIndex, this.rowItemSwipeStates[this.touchedRowItemIndex], angle);
      if (this.rowItemSwipeStates[this.touchedRowItemIndex] != 0) {
        //console.log("Cancel Move Open Card", $event.cancelable);
        if ($event.cancelable) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }
  }

  documentScrollerHandler($event) {
    //console.log("documentScrollerHandler");
    this.doResetPositions(-1);
  }

  calculateDimensions() {
    console.log("calculateDimensions", screen.width, screen.height, window.innerWidth, window.innerHeight);
    this.ROW_ITEM_SWIPE_LEFT_MAX = -this.ACTION_DIV_WIDTH_RIGHT;
    this.ROW_ITEM_SWIPE_RIGHT_MAX = this.ACTION_DIV_WIDTH_LEFT;
    //this.ACCOUNT_CARD_SWIPE_DISTANCE = toVw(160);
    this.ROW_ITEM_SWIPE_DURATION = 200 / 1000.0;

    console.log("calculateDimensions", this.ROW_ITEM_SWIPE_LEFT_MAX, this.ROW_ITEM_SWIPE_RIGHT_MAX, this.ROW_ITEM_SWIPE_DURATION);
  }

  teardownAnimations() {
    this.calculateDimensions();
    this.rowItemSwipeRightAIs.forEach((item) => {
      if (item) {
        item.kill();
        item = null;
      }
    });
    this.rowItemSwipeLeftAIs.forEach((item) => {
      if (item) {
        item.kill();
        item = null;
      }
    });
    if (this.scrollerunlistener) {
      this.scrollerunlistener();
    }
    document.body.removeEventListener("touchmove", this.documentTouchMoveHandler.bind(this), { capture: true });
  }

  setupAnimations() {
    this.rowItemSwipeLeftAIs = new Array();
    this.rowItemSwipeRightAIs = new Array();
    this.rowItemSwipeStates = new Array();

    this.mattabledataSource.filteredData.forEach((item, index) => {
      let target = "#gridRowItem_" + this.randomNumber + "_" + index;
      this.rowItemSwipeIndexes.push(index);

      let taskItemSwipeLeftAI = gsap.timeline({
        paused: true,
        duration: this.ROW_ITEM_SWIPE_DURATION,
        ease: "power1.in",
        smoothChildTiming: false,
      });

      taskItemSwipeLeftAI.eventCallback("onComplete", () => {
        console.log("onComplete taskItemSwipeLeftAI", index);
        this.actionOpned = true;

        this.rowItemSwipeStates[index] = -1;
        this.doResetPositions(index);
        this.doResetPlay();
      });
      taskItemSwipeLeftAI.eventCallback("onReverseComplete", () => {
        console.log("onReverseComplete taskItemSwipeLeftAI", index);
        this.actionOpned = false;

        this.rowItemSwipeStates[index] = 0;
        this.doResetPlay();
      });

      // box-shadow: 0 0 8px #00000029;
      // border-radius: 8px;

      taskItemSwipeLeftAI.fromTo(target,
        { css: { x: 0, boxShadow: 'none', borderRadius: 0, backgroundColor: 'transparent' } },
        {
          css: { x: this.ROW_ITEM_SWIPE_LEFT_MAX, boxShadow: '0 0 8px #00000029', borderRadius: 8, backgroundColor: '#FFFFFF' }
        },
        0
      );

      taskItemSwipeLeftAI.fromTo(target + " + .grid-row-action-item", { css: { opacity: 0, width: 0 } }, { css: { opacity: 1, width: (this.ACTION_DIV_WIDTH_RIGHT) } }, 0);

      this.rowItemSwipeLeftAIs[index] = taskItemSwipeLeftAI;

      let taskItemSwipeRightAI = gsap.timeline({
        paused: true,
        duration: this.ROW_ITEM_SWIPE_DURATION,
        ease: "power1.in",
        smoothChildTiming: false,
      });
      taskItemSwipeRightAI.eventCallback("onComplete", () => {
        this.rowItemSwipeStates[index] = 1;
        this.doResetPositions(index);
        this.doResetPlay();
      });
      taskItemSwipeRightAI.eventCallback("onReverseComplete", () => {
        this.actionOpned = false;
        // $(target).removeClass("open");
        this.rowItemSwipeStates[index] = 0;
        this.doResetPlay();
      });

      taskItemSwipeRightAI.fromTo(target,
        { css: { x: 0 } },
        {
          css: { x: this.ROW_ITEM_SWIPE_RIGHT_MAX }
        },
        0
      );

      // taskItemSwipeRightAI.fromTo(target + " + .grid-row-action-item", { css: { opacity: 0, width: (this.ACTION_DIV_WIDTH_LEFT - 40) } }, { css: { opacity: 1, width: (this.ACTION_DIV_WIDTH_LEFT) } }, 0);
      // this.rowItemSwipeRightAIs[index] = taskItemSwipeRightAI;

      this.rowItemSwipeStates[index] = 0;

      this.scrollerunlistener = this.renderer2.listen(document.body, "scroll", this.documentScrollerHandler.bind(this));
    });

  }

  getAccountCardSwipeLeftProgress(deltaX) {
    let progress = Math.abs((deltaX / this.ROW_ITEM_SWIPE_LEFT_MAX) * 100);
    return Math.min(100, progress);
  }

  getAccountCardSwipeRightProgress(deltaX) {
    let progress = Math.abs((deltaX / this.ROW_ITEM_SWIPE_RIGHT_MAX) * 100);
    return Math.min(100, progress);
  }

  seekSwipeLeftAnimation(index, progress) {
    let seekTime = this.ROW_ITEM_SWIPE_DURATION * (progress / 100);
    console.log("Seek", progress, seekTime, this.rowItemSwipeStates[index]);
    let animeInstances = [];
    animeInstances.push(this.rowItemSwipeLeftAIs[index]);
    animeInstances.forEach((item) => {
      if (item) {
        item.pause().totalProgress(progress / 100.0);
      }
    });
  }

  seekSwipeRightAnimation(index, progress) {
    let seekTime = this.ROW_ITEM_SWIPE_DURATION * (progress / 100);
    console.log("Seek", progress, seekTime, this.rowItemSwipeStates[index]);
    let animeInstances = [];
    animeInstances.push(this.rowItemSwipeRightAIs[index]);
    animeInstances.forEach((item) => {
      if (item) {
        item.pause().totalProgress(progress / 100.0);
      }
    });
  }

  panStartHandler($event, index) {
    if (this.rowItemSwipeRightAIs || this.rowItemSwipeLeftAIs) {
      // this._observableService.triggerTaskSwipe();
    }

    console.log("Pan Start", index, this.selectedRowItemIndex, $event.center.x);
    if (this.playInProgress) {
      console.log("Pan Start Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    let target = "#gridRowItem_" + this.randomNumber + "_" + index;
    this.actionOpned = false;
    // $(target).removeClass("open");

    if (this.selectedRowItemIndex == -1) {
      this.doResetPositions(index);
      this.playInProgress = false;
      this.selectedRowItemIndex = index;
    }
  }

  panEndHandler($event, index) {
    this.panHorizontalInProgress = false;
    console.log("Pan End", index, this.swipedRowItemIndex, this.selectedRowItemIndex, $event.deltaX);
    if (index == this.swipedRowItemIndex) {
      this.swipedRowItemIndex = -1;
      console.log("Pan End Skipped Pan End On Swipe Event");
      return;
    }

    if (this.swipedRowItemIndex != -1 && this.playInProgress) {
      console.log("Pan End Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (index != this.selectedRowItemIndex) {
      console.log("Pan End Index Not Eligible For Swipe");
      return;
    }

    if ($event.deltaX >= 0) {
      if (this.rowItemSwipeStates[index] == 0) {
        let progress = this.getAccountCardSwipeRightProgress($event.deltaX);
        console.log("Pan End Swipe Right", index, this.selectedRowItemIndex, $event.deltaX, progress);
        if (progress > 50) {
          console.log("Pan End - Swipe Right 0 Play");
          this.playInProgress = true;
          //this.seekSwipeRightAnimation(index, progress);
          this.rowItemSwipeRightAIs[index].play();
        } else {
          console.log("Pan End - Swipe Right 0 Reverse");
          this.playInProgress = true;
          //this.seekSwipeRightAnimation(index, progress);
          this.rowItemSwipeRightAIs[index].reverse();
        }
      }
      else if (this.rowItemSwipeStates[index] == -1) {
        let progress = this.getAccountCardSwipeLeftProgress($event.deltaX);
        console.log("Pan End Swipe Left", index, this.selectedRowItemIndex, $event.deltaX, progress);
        if (progress > 50) {
          console.log("Pan End - Swipe Right -1 Reverse");
          this.playInProgress = true;
          //this.seekSwipeLeftAnimation(index, progress);
          this.rowItemSwipeLeftAIs[index].reverse();
        } else {
          console.log("Pan End - Swipe Right -1 Play");
          this.playInProgress = true;
          //this.seekSwipeLeftAnimation(index, progress);
          this.rowItemSwipeLeftAIs[index].play();
        }
      } else {
        console.log("Pan End - Swipe Right 1 Rejected");
        this.doResetPlay();
      }
    } else if ($event.deltaX < 0) {
      if (this.rowItemSwipeStates[index] == 0) {
        let progress = this.getAccountCardSwipeLeftProgress($event.deltaX);
        console.log("Pan End Swipe Left", index, this.selectedRowItemIndex, $event.deltaX, progress);
        if (progress > 50) {
          console.log("Pan End - Swipe Left 0 Play");
          this.playInProgress = true;
          //this.seekSwipeLeftAnimation(index, progress);
          this.rowItemSwipeLeftAIs[index].play();
        } else {
          console.log("Pan End - Swipe Left 0 Reverse");
          this.playInProgress = true;
          //this.seekSwipeLeftAnimation(index, progress);
          this.rowItemSwipeLeftAIs[index].reverse();
        }
      } else if (this.rowItemSwipeStates[index] == 1) {
        let progress = this.getAccountCardSwipeRightProgress($event.deltaX);
        console.log("Pan End Swipe Right", index, this.selectedRowItemIndex, $event.deltaX, progress);
        if (progress > 50) {
          console.log("Pan End - Swipe Right 1 Reverse");
          this.playInProgress = true;
          //this.seekSwipeRightAnimation(index, progress);
          this.rowItemSwipeRightAIs[index].reverse();
        } else {
          console.log("Pan End - Swipe Right 1 Play");
          this.playInProgress = true;
          //this.seekSwipeRightAnimation(index, progress);
          this.rowItemSwipeRightAIs[index].play();
        }
      } else {
        console.log("Pan End - Swipe Left -1 Rejected");
        this.doResetPlay();
      }
    }
    if (this.playInProgress) {
      setTimeout(() => {
        this.doResetPlay();
      }, 300);
    }
  }

  panLeftHandler($event, index) {
    let target = "#gridRowItem_" + this.randomNumber + "_" + index;
    let x: number = parseInt(gsap.getProperty(target + " + .grid-row-action-item", "x") + "");
    if (this.playInProgress) {
      //console.log("Pan Left Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (index == this.swipedRowItemIndex) {
      //console.log("Pan Left Skipped - Pan Left On Swipe Event", index, this.swipedRowItemIndex);
      return;
    }

    if (this.selectedRowItemIndex == -1) {
      //console.log("Pan Left Skipped - No Selected Card", index);
      return;
    }

    this.panHorizontalInProgress = true;

    if ($event.deltaX > 0) {
      if (this.rowItemSwipeStates[index] == 0 || this.rowItemSwipeStates[index] == 1) {
        /*SWIPE RIGHT SEEK REVERSE*/
        let progress = this.getAccountCardSwipeRightProgress($event.deltaX);
        //console.log("Pan Left Swipe Right Seek Reverse", index, this.rowItemSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeRightAnimation(index, progress);
        }
      } else if (this.rowItemSwipeStates[index] == -1) {
        /*SWIPE LEFT SEEK REVERSE*/
        let progress = 100 - this.getAccountCardSwipeLeftProgress($event.deltaX);
        //console.log("Pan Left Swipe Left Seek Reverse", index, this.rowItemSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeLeftAnimation(index, progress);
        }
      }
    } else if ($event.deltaX < 0) {
      if (this.rowItemSwipeStates[index] == 0) {
        /*SWIPE LEFT SEEK PLAY*/
        let progress = this.getAccountCardSwipeLeftProgress($event.deltaX);
        //console.log("Pan Left Swipe Left Seek Play", index, this.rowItemSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeLeftAnimation(index, progress);
        }
      } else if (this.rowItemSwipeStates[index] == 1) {
        /*SWIPE RIGHT SEEK REVERSE*/
        let progress = 100 - this.getAccountCardSwipeRightProgress($event.deltaX);
        //console.log("Pan Left Swipe Right Seek Reverse", index, this.rowItemSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeRightAnimation(index, progress);
        }
      }
    }
  }

  panRightHandler($event, index) {
    let target = "#gridRowItem_" + this.randomNumber + "_" + index;
    let x = parseInt(gsap.getProperty(target + " .grid-row-action-item", "x") + "");
    if (this.playInProgress) {
      console.log("Pan Right Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (index == this.swipedRowItemIndex) {
      console.log("Pan Right Skipped - Pan Right On Swipe Event", index, this.swipedRowItemIndex);
      return;
    }

    if (this.selectedRowItemIndex == -1) {
      console.log("Pan Right Skipped - No Selected Card", index, this.selectedRowItemIndex);
      return;
    }

    this.panHorizontalInProgress = true;

    if ($event.deltaX > 0) {
      if (this.rowItemSwipeStates[index] == 0) {
        /*SWIPE RIGHT SEEK*/
        let progress = this.getAccountCardSwipeRightProgress($event.deltaX);
        console.log("Pan Right Swipe Right Seek Play", index, this.rowItemSwipeStates[index], progress);
        if (progress >= 0 && progress < 100) {
          this.seekSwipeRightAnimation(index, progress);
        }
      } else if (this.rowItemSwipeStates[index] == -1) {
        /*SWIPE LEFT SEEK REVERSE*/
        let progress = 100 - this.getAccountCardSwipeLeftProgress($event.deltaX);
        console.log("Pan Right Swipe Left Seek Reverse", index, this.rowItemSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeLeftAnimation(index, progress);
        }
      }
    } else if ($event.deltaX < 0) {
      if (this.rowItemSwipeStates[index] == 0 || this.rowItemSwipeStates[index] == -1) {
        /*SWIPE LEFT SEEK PLAY*/
        let progress = this.getAccountCardSwipeLeftProgress($event.deltaX);
        console.log("Pan Right Swipe Left Seek Play", index, this.rowItemSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeLeftAnimation(index, progress);
        }
      } else if (this.rowItemSwipeStates[index] == 1) {
        /*SWIPE RIGHT SEEK REVERSE*/
        let progress = 100 - this.getAccountCardSwipeRightProgress($event.deltaX);
        console.log("Pan Right Swipe Right Seek Reverse", index, this.rowItemSwipeStates[index], progress);
        if (progress > 0 && progress < 100) {
          this.seekSwipeRightAnimation(index, progress);
        }
      }
    }
  }

  touchStartHandler($event, index) {
    console.log("Touch Start", index);
    this.rowItemTouchInProgress = true;
    this.touchedRowItemIndex = index;
    this.touchState.y1 = $event.changedTouches && $event.changedTouches[0].clientY;
    this.touchState.x1 = $event.changedTouches && $event.changedTouches[0].clientX;
  }

  swipeLeftHandler($event, index) {
    if (this.rowItemSwipeRightAIs || this.rowItemSwipeLeftAIs) {
      // this._observableService.triggerTaskSwipe(index);
    }

    console.log("Swipe Left", index, this.selectedRowItemIndex, this.rowItemSwipeStates[index]);
    if (this.playInProgress) {
      console.log("Swipe Left Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    console.log("Swipe Left Accepted ");
    if (this.rowItemSwipeStates[index] == 1) {
      this.playInProgress = true;
      this.swipedRowItemIndex = index;
      this.rowItemSwipeRightAIs[index].reverse();
    } else if (this.rowItemSwipeStates[index] == 0) {
      this.playInProgress = true;
      this.swipedRowItemIndex = index;
      this.rowItemSwipeLeftAIs[index].play();
    }
  }

  swipeRightHandler($event, index) {
    if (this.rowItemSwipeRightAIs || this.rowItemSwipeLeftAIs) {
      // this._observableService.triggerTaskSwipe(this.index);
    }

    console.log("Swipe Right", index, this.selectedRowItemIndex, this.rowItemSwipeStates[index]);
    if (this.playInProgress) {
      console.log("Swipe Right Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    console.log("Swipe Right Accepted");

    if (this.rowItemSwipeStates[index] == -1) {
      this.playInProgress = true;
      this.swipedRowItemIndex = index;
      this.rowItemSwipeLeftAIs[index].reverse();
    } else if (this.rowItemSwipeStates[index] == 0) {
      this.playInProgress = true;
      this.swipedRowItemIndex = index;
      this.rowItemSwipeRightAIs[index].play();
    }
  }

  doResetPositions(index) {
    this.rowItemSwipeIndexes.forEach((item_index, i) => {
      if (item_index != index) {
        if (this.rowItemSwipeStates[item_index] == -1) {
          this.rowItemSwipeLeftAIs[item_index].reverse();
          //this.seekSwipeLeftAnimation(item_index, 0);
        } else if (this.rowItemSwipeStates[item_index] == 1) {
          this.rowItemSwipeRightAIs[item_index].reverse();
          //this.seekSwipeRightAnimation(item_index, 0);
        }
        this.rowItemSwipeStates[item_index] = 0;
      }
    });
  }

  doResetPlay() {
    this.selectedRowItemIndex = -1;
    this.playInProgress = false;
    this.changeDetectorRef.detectChanges();
  }

}

export class ColumnDefinition {
  showSearchPopup: boolean = false;
  action: "sort" | "search" | "sort&search" | undefined;
  columnDef: string;
  header: string;
  cell: any;
  width?: number | string;
  columnType: ColumnType | undefined;
  searchType: SearchType | undefined;
  sortType: SortType | undefined;
  searchText?: string | string[];
  fromValue?: string;
  toValue?: string;

  constructor(
    _action: "sort" | "search" | "sort&search" | undefined,
    _columnDef: string,
    _header: string,
    _cell: any,
    _width: number | string,
    _columnType: ColumnType | undefined,
    _searchType: SearchType | undefined,
    _sortType: SortType | undefined,
    _searchText?: string | string[],
    _fromValue?: string,
    _toValue?: string
  ) {
    this.columnDef = _columnDef;
    this.header = _header;
    this.cell = _cell;
    this.width = _width;
    this.columnType = _columnType;
    this.searchType = _searchType;
    this.searchText = _searchText;
    this.fromValue = _fromValue;
    this.toValue = _toValue;
    this.sortType = _sortType;
    this.action = _action;
  }


}
